export enum CampaignType {
  ClientRebate = 0,
  ClientContest = 1,
  IbContest = 2,
  LuckyDraw = 3,
  BonusMargin = 4,
  TradingPool = 5,
}

export const isCampaignClientRebateType = (campaignType: CampaignType | undefined) => {
  return CampaignType.ClientRebate === campaignType
}

export const isCampaignClientContestType = (campaignType: CampaignType | undefined) => {
  return CampaignType.ClientContest === campaignType
}

export const isCampaignBonusMarginType = (campaignType: CampaignType | undefined) => {
  return CampaignType.BonusMargin === campaignType
}
